import script from "./AppSaveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSaveButton.vue?vue&type=script&setup=true&lang=js"

import "./AppSaveButton.vue?vue&type=style&index=0&id=4d4ffcb3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4ffcb3"]])

export default __exports__